import _ from 'lodash';
import Vue from 'vue';

class Collection {
  get list() {
    return this.models;
  }

  constructor(list, Model) {
    Vue.set(this, 'models', []);
    _.forEach(list, (value) => {
      this.models.push(new Model(value));
    });
  }
}

export default Collection;
